import type { PropsWithChildren, ReactNode } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

interface IHeaderProps {
    rightSlot?: ReactNode;
}

export const Header = ({ children, rightSlot }: PropsWithChildren<IHeaderProps>) => (
    <Flex
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        gap="16px"
    >
        <Flex
            alignItems="center"
            gap="16px"
            flexGrow={1}
            minWidth={0}
        >
            {children}
        </Flex>
        {rightSlot}
    </Flex>
);
